import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  importProvidersFrom,
  input,
  OnInit,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';

import { DashboardComponent } from './dashboard/dashboard.component';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { WidgetRendererComponent } from './widget-renderer/widget-renderer.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { SideNavbarComponent } from '@shared-lib/chart-components/side-navbar/side-navbar.component';

@Component({
  selector: 'app-root',
  providers: [HttpClientModule],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatRadioModule,
    SideNavbarComponent,
    NgxEchartsModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  data: any;
  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {
    this.init();
  }
  ngOnInit(): void {}
  async init() {
    const loggedIn = await this.keycloakService.isLoggedIn();
    if (!loggedIn) {
      this.keycloakService.login();
    }
  }

  logout(): void {
    this.keycloakService.logout();
  }
}
